import React from "react";
import { Navigate } from "react-router-dom";
import Menu from "@shared/layout/Menu";
import Programs from "@features/programs/components/Programs";
import Program from "@features/programs/components/Program";
import PatientCalendar from "@features/programs/components/PatientCalendar";
import Milestones from "@features/programs/components/Milestones";

const routes = [
  {
    path: "/",
    element: (
      <>
        <Navigate to="/dashboard" />
        <Menu content={<Programs />} />
      </>
    ),
    isProtected: true,
  },
  {
    path: "/dashboard",
    element: <Menu content={<Programs />} />,
    isProtected: true,
  },
  {
    path: "/programs",
    element: <Menu content={<Programs />} />,
    isProtected: true,
  },
  {
    path: "/programs/:id",
    element: <Menu content={<Program />} />,
    isProtected: true,
  },
  {
    path: "/calendar",
    element: <Menu content={<PatientCalendar />} />,
    isProtected: true,
  },
  {
    path: "/milestones",
    element: <Menu content={<Milestones />} />,
    isProtected: true,
  },
];

export default routes;
